import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Draggable as DraggableContainer } from 'react-beautiful-dnd'

export default class Draggable extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    index: PropTypes.number,
    style: PropTypes.object,
    props: PropTypes.object,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    index: 0,
    className: '',
    style: {},
    props: {},
    disabled: false,
  }

  render() {
    const { id, index, children, className, style, props, disabled } = this.props
    const draggableId = JSON.stringify({ id, ...props })
    const getStyle = (draggableProps, isDragging) => {
      return { ...draggableProps.style, ...(isDragging ? style : {}) }
    }

    if (disabled) {
      return children
    }

    return (
      <DraggableContainer draggableId={draggableId} index={index}>
        {({ innerRef, draggableProps, dragHandleProps }, { isDragging }) => (
          <div
            className={classnames(className, { dragging: isDragging })}
            ref={innerRef}
            {...draggableProps}
            {...dragHandleProps}
            style={getStyle(draggableProps, isDragging)}
          >
            {children}
          </div>
        )}
      </DraggableContainer>
    )
  }
}
